export default {
  "welcome": "خوش آمدید",
  "greeting": "ہیلو، {name}!",
  "about": "ہمارے بارے میں",
  "contact": "رابطہ",
  "products": "مصنوعات",
  "cart": "آپ کی ٹوکری",
  "items": "کوئی شے نہیں | 1 شے | {count} اشیاء",

  // Navbar and common
  "home": "ہوم",
  "Solution": "حل",
  "Focused": "فوکس",
  "Technology": "ٹیکنالوجی",
  "Efficiency": "موثریت",
  "Scale": "اسکیل",
  "brand": "انوویٹو پے",
  "language": "زبان",

  // Homepage (hero)
  "hero": {
    "brand": "انوویٹو پے",
    "titleLine2": "ادائیگیاں جمع کرنا",
    "titleLine3": "فوری اور بے جھنجھٹ بناتا ہے",
    "desc": "اپنے کاروبار کو بڑے موبائل والیٹس کے ساتھ مکمل طور پر مربوط ایمبیڈڈ حل کے ذریعے فوری طور پر ڈیجیٹل ادائیگیاں قبول کرنے کے قابل بنائیں۔",
    "emailPlaceholder": "ای میل پتہ",
    "cta": "ابھی شروع کریں >",
    "sending": "بھیج رہے ہیں…",
    "invalidEmail": "ای میل فارمیٹ درست نہیں",
    "sent": "کامیابی سے بھیج دیا گیا",
    "sendFailed": "بھیجنے میں ناکامی، بعد میں دوبارہ کوشش کریں"
  },

  // HomePage1
  "hp1": {
    "titleLine1": "ایک چیک آؤٹ،",
    "titleLine2": "ہر ادائیگی کا طریقہ",
    "kicker": "اپنی آمدنی کو تیز کریں",
    "headline1": "معاملات کی حقیقی وقت میں نگرانی کریں",
    "headline2": "",
    "bullet1": "ہر لین دین کا مکمل جائزہ حاصل کریں جس میں آئٹم کے لحاظ سے آمدنی کی بصیرت شامل ہو۔",
    "bullet2": "ایک متحد ریئل ٹائم ڈیش بورڈ کے ذریعے تمام ادائیگیوں کو ٹریک کریں۔",
    "goToSlide": "سلائیڈ پر جائیں",

    // Second slide
    "titleLine1_2": "ایک چیک آؤٹ،",
    "titleLine2_2": "ہر ادائیگی کا طریقہ",
    "kicker_2": "تمام لین دین کو درستگی سے ٹریک کریں",
    "headline1_2a": "تیز اور محفوظ ادائیگیاں",
    "headline1_2b": "",
    "bullet1_2": "ہمارے ایکسپریس چیک آؤٹ کے ساتھ صرف 3 مراحل میں بے روک ٹوک ادائیگیاں پروسیس کریں۔",
    "bullet2_2": "ایک مرکزی ہب میں متوازن، اپ ٹو ڈیٹ ادائیگی کے میٹرکس کو برقرار رکھیں۔",

    // Third slide
    "titleLine1_3": "ایک چیک آؤٹ،",
    "titleLine2_3": "ہر ادائیگی کا طریقہ",
    "kicker_3": "صارفین کے لیے معاونت",
    "headline1_3a": "جب ضرورت ہو تو قابلِ اعتماد معاونت",
    "headline1_3b": "",
    "bullet1_3": "پیک لوڈ پر فی سیکنڈ 50,000 لین دین سنبھالنے کے لیے سختی سے ٹیسٹ کیا گیا۔",
    "bullet2_3": "ایک ریسپونسو، انٹوئٹو انٹرفیس میں ہزاروں منظرنامے سمیلیٹ کریں۔",

    // Fourth slide
    "titleLine1_4": "ایک چیک آؤٹ،",
    "titleLine2_4": "ہر ادائیگی کا طریقہ",
    "kicker_4": "ترقی کو بے روک ٹوک تیز کریں",
    "headline1_4a": "موثر اور صارف مرکز ادائیگیاں",
    "headline1_4b": "",
    "bullet1_4": "قابلِ تخصیص مرچنٹ سیٹلمنٹس کو فعال بنائیں — بے روک ٹوک، شفاف، اور فیس فری۔",
    "bullet2_4": "خودکار آمدنی کی رپورٹنگ اکروئل اکاؤنٹنگ کو آسان بناتی ہے تاکہ درست بک کلوزر ہو سکے۔"
  },

  // HomePage2
  "hp2": {
    "bgAlt": "پس منظر کی تصویر",
    "supportSubtitle": "صارفین کی مرکزیت والی معاونت",
    "supportTitle": "جب ضرورت ہو، قابلِ اعتماد معاونت",
    "supportDesc1": "ہمارا 24/7 ڈیجیٹل سپورٹ ہب تیزی اور درستگی کے ساتھ سوالات کا حل فراہم کرتا ہے۔",
    "supportDesc2": "ایک کلک میں ہماری مخصوص سپورٹ ٹیم سے فوری مدد حاصل کریں۔",
    "scalabilityTitle": "بے مثال اسکیل ایبلٹی",
    "stat1Number": "10 کروڑ سے زائد",
    "stat1Desc": "محفوظ کردہ ادائیگی کے طریقے — اپنے صارفین کے پسندیدہ ادائیگی کے آلات کو بغیر کسی رکاوٹ کے ذخیرہ کریں اور منظم کریں۔",
    "stat2Number": "۳۰,۰۰۰ سے زائد",
    "stat2Desc": "تیز رفتار پراسیسنگ — فی سیکنڈ ہزاروں لین دین سنبھالنے کی صلاحیت کے ساتھ۔",
    "stat3Number": "۱۰ ارب",
    "stat3Desc": "سالانہ اربوں لین دین — ہر حجم کے کاروباروں کی طرف سے اعتماد یافتہ۔"
  },

  // HomePage3
  "hp3": {
    "mainTitle": "ادائیگی کی ٹیکنالوجی",
    "subtitle": "ہزاروں تاجروں کا قابلِ اعتماد انتخاب",
    "cta": "انوواکشن پیمنٹ گیٹ وے کیوں منتخب کریں",
    "features": {
      "instantActivation": {
        "title": "فوری ایکٹیویشن",
        "desc": "انوواکشن کم سے کم دستاویزات کے ساتھ 100% آن لائن آن بورڈنگ فراہم کرتا ہے، جس سے آپ کا کاروبار بآسانی لائیو ہو جاتا ہے۔"
      },
      "easyIntegration": {
        "title": "آسان انضمام",
        "desc": "انوواکشن کے طاقتور API اور قابلِ تخصیص SDK کے ساتھ، آپ 30 منٹ سے بھی کم وقت میں صرف چند لائن کوڈ کے ذریعے ادائیگیاں قبول کرنا شروع کر سکتے ہیں۔"
      },
      "multipleMethods": {
        "title": "متعدد ادائیگی کے طریقے",
        "desc": "اپنے صارفین کو ان کی پسند کے مطابق ادائیگی کرنے کی سہولت دیں — ڈیبٹ/کریڈٹ کارڈز، آن لائن بینکنگ، InX Wallet اور مزید کی معاونت۔"
      },
      "secureTransactions": {
        "title": "محفوظ لین دین",
        "desc": "بینک سطح کی سکیورٹی اور اینڈ ٹو اینڈ انکرپشن آپ کے صارفین کے ڈیٹا کو ہر وقت محفوظ رکھتی ہے۔"
      },
      "support": {
        "title": "صنعت میں نمایاں کامیابی کی شرحیں",
        "desc": "ذہین روٹنگ اور براہِ راست بینک انٹیگریشنز کی بدولت، انوویشن یقینی بناتا ہے کہ آپ کے صارفین کی ادائیگیاں ہر بار کامیابی سے مکمل ہوں۔"
      },
      "support1": {
        "title": "پاکستان کا سب سے مقبول چیک آؤٹ تجربہ",
        "desc": "10 کروڑ سے زائد پاکستانی انوویشن کے چیک آؤٹ پر پے کو منتخب کرتے ہیں۔ اب آپ اپنے صارفین کو وہ بے روک ٹوک تجربہ فراہم کر سکتے ہیں جسے وہ جانتے اور پسند کرتے ہیں۔"
      },
      "support2": {
        "title": "مخصوص معاونت",
        "desc": "ہر انوویشن کا مرچنٹ اور گیٹ وے صارف بغیر کسی اضافی قیمت کے ٹول فری فون اور ای میل کے ذریعے ذاتی معاونت حاصل کرتا ہے۔"
      },
    }
  },

  // HomePage4
  "hp4": {
    "mainTitle": "طاقتور بزنس ڈیش بورڈ",
    "subtitle": "اپنے کاروبار کی کارکردگی کو آسانی سے منظم اور مانیٹر کریں۔",
    "slides": {
      "analytics": {
        "title": "ریئل ٹائم اینالیٹکس",
        "desc": "ریئل ٹائم اینالیٹکس اور حسبِ منشا رپورٹس تک رسائی حاصل کریں۔"
      },
      "collection": {
        "title": "پیمنٹ کلیکشن",
        "desc": "باآسانی ادائیگیاں وصول کرنے کے لیے پیمنٹ لنکس بنائیں۔"
      },
      "dataIntegration": {
        "title": "ڈیٹا انٹیگریشن",
        "desc": "بلا رکاوٹ ڈیٹا انٹیگریشن اور کنیکٹیوٹی۔"
      }
    }
  },

  // HomePage5
  "hp5": {
    "mainHeading": "بہتر فیصلوں کے لیے ڈیٹا پر مبنی بصیرت",
    "description1": "ہمارے ایڈوانسڈ پیمنٹ اینالیٹکس ماڈیول تک مفت رسائی حاصل کریں اور ریئل ٹائم ڈیٹا کی بنیاد پر فیصلے کریں۔",

    "features": {
      "benchmark": "صنعتوں، پلیٹ فارمز اور ڈیوائسز میں کامیابی کی شرح کا موازنہ کریں",
      "measure": "مختلف ادائیگی کے ذرائع کی کارکردگی کو ناپیں",
      "understand": "گاہک کے رویے اور خریداری کے رجحانات کو سمجھیں",
      "tailor": "اپنی مصنوعات اور خدمات کو گاہک کی ترجیحات کے مطابق بنائیں"
    }
  },

  // HomePage6
  "hp6": {
    "title": "ہمارے کلائنٹس",
    "prev": "پچھلا",
    "next": "اگلا",
    "illustrationAlt": "کلائنٹس کی عکاسی"
  },

  "footer": {
    "telephone": "ٹیلیفون نمبر",
    "customerServiceEmail": "کسٹمر سروس ای میل",
    "copyright": "کاپی رائٹ © Innovative Visionary Studios (Pvt) Ltd.",
    "backToTop": "اوپر جائیں"
  }
}
